import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TrailerInterventionService } from '../../stores/trailer-intervention.service';
import { notify } from 'shared';

@Component({
  selector: 'app-rating-dialog',
  templateUrl: './rating-dialog.component.html',
  styleUrls: ['./rating-dialog.component.scss']
})
export class RatingDialogComponent implements OnInit {
  @Output() onRating = new EventEmitter<void>();
  
  visible = false;
  interventionId: number;
  selectedRating: string | null = null;
  isEditing = false; // Track if we're editing an existing rating
  
  ratingOptions = [
    { value: 'EXACT', label: 'Données exactes' },
    { value: 'APPROXIMATELY_CORRECT', label: 'Données approximativement correctes' },
    { value: 'INEXACT', label: 'Données inexactes' }
  ];

  constructor(
    private trailerInterventionService: TrailerInterventionService
  ) {
  }

  ngOnInit(): void {
  }

  show(interventionId: number, currentRating?: string): void {
    this.interventionId = interventionId;
    this.selectedRating = currentRating || null;
    this.isEditing = !!currentRating; // Set editing mode if there's a current rating
    this.visible = true;
  }

  close(): void {
    this.visible = false;
    this.isEditing = false;
  }

  submit(): void {
    if (!this.selectedRating) {
      notify('Veuillez sélectionner une évaluation', 'error', 3000);
      return;
    }
    
    this.trailerInterventionService.updateDataAccuracyRating(this.interventionId, this.selectedRating).subscribe({
      next: () => {
        const message = this.isEditing 
          ? 'Évaluation modifiée avec succès' 
          : 'Évaluation enregistrée avec succès';
        notify(message, 'success', 3000);
        this.onRating.emit();
        this.close();
      },
      error: (err) => {
        console.error('Error updating rating:', err);
        notify('Erreur lors de la mise à jour de l\'évaluation', 'error', 3000);
      }
    });
  }
}

